import './SocialButtons.sass';

import { SocialButtonsProps } from './SocialButtons.interface';
import React from 'react';

export const SocialButtons = ({ link, className }: SocialButtonsProps) => {
  return (
    <div className={`Social__buttons ${className || ''}`}>
      <a
        href={`https://t.me/share/url?url=${link}`}
        target="_blank"
        className="Social__button telegram"
        rel="noreferrer"
      >
        Telegram
      </a>
      <a
        href={`https://vk.com/share.php?url=${link}`}
        target="_blank"
        className="Social__button vk"
        rel="noreferrer"
      >
        VK
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${link}`}
        className="Social__button fb"
        target="_blank"
        rel="noreferrer"
      >
        Facebook
      </a>
      <a
        href={`https://twitter.com/share?url=${link}`}
        target="_blank"
        className="Social__button twitter"
        rel="noreferrer"
      >
        Twitter
      </a>
    </div>
  );
};
